import { render, staticRenderFns } from "./showApplicantDetails.vue?vue&type=template&id=50c0e0fc&scoped=true&"
import script from "./showApplicantDetails.vue?vue&type=script&lang=js&"
export * from "./showApplicantDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c0e0fc",
  null
  
)

export default component.exports